import { AiAgentListing } from "@/model/interface/AiAgent";

function formatAmount(amount: number, maximumDecimals: number): string {
  if (Number.isInteger(amount)) {
    return `$${amount}`;
  }
  const minimumDecimals = Math.min(2, maximumDecimals);
  return `$${amount.toLocaleString("en-US", { minimumFractionDigits: minimumDecimals, maximumFractionDigits: maximumDecimals })}`;
}

export function listingMonthlyLabel(listing: AiAgentListing): string {
  const monthlyFee = listing.effectiveMonthlyFee;
  if (monthlyFee === null || monthlyFee === undefined) {
    return "Not available";
  }
  return monthlyFee > 0 ? `${formatAmount(monthlyFee, 2)}/mo` : "Free";
}

export function listingListPriceLabel(listing: AiAgentListing): string | null {
  const effectiveFee = listing.effectiveMonthlyFee;
  const isDiscounted =
    listing.visibility === "PRIVATE" &&
    listing.discountPercent > 0 &&
    effectiveFee !== null &&
    effectiveFee !== undefined &&
    listing.monthlyFee > effectiveFee;
  if (!isDiscounted) {
    return null;
  }
  return `${formatAmount(listing.monthlyFee, 2)}/mo, ${listing.discountPercent}% off`;
}

export function listingPerMinuteLabel(listing: AiAgentListing): string {
  const perMinuteFee = listing.effectivePerMinuteFee;
  if (perMinuteFee === null || perMinuteFee === undefined) {
    return "Not available";
  }
  return `${formatAmount(perMinuteFee, 4)}/min`;
}

export function listingCostSentence(listing: AiAgentListing): string {
  const monthlyFee = listing.effectiveMonthlyFee ?? 0;
  const usage = `${listingPerMinuteLabel(listing).replace("/min", "")} per minute of usage beyond the AI minutes included in your plan`;
  const base = monthlyFee > 0
    ? `This agent costs ${formatAmount(monthlyFee, 2)} per month, plus ${usage}.`
    : `This agent has no monthly fee. You pay ${usage}.`;
  const outboundFee = listing.effectiveOutboundMonthlyFee;
  if (outboundFee === null || outboundFee === undefined || outboundFee === monthlyFee) {
    return base;
  }
  return `${base} If you switch it to outbound calling, the monthly price becomes ${formatAmount(outboundFee, 2)}.`;
}
